/**
 * contrastDetection
 * accepts a hex color in string format. if argument fails to produce a useable number
 * it will return NaN up to caller. Compares values brightness to absolute white if
 * the value returns true then the value is more white then black and vice versa
 *
 * Note if you are expecting to use colors around #888888 this may not be the best solution
 */

window.contrastDetection = function colorContrastDetection(hexColorString) {
  try {
    var color = parseInt(hexColorString.replace("#", ""), 16);
    var middleGray = parseInt("ffffff", 16) / 2;
    if (isNaN(color)) {
      throw "Color can not be parsed";
    }
    return color > middleGray;
  } catch (e) {
    console.error(e);
  }
};
